/* tslint:disable */
/* eslint-disable */
/**
 * Conversation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LandbotCompletenessResponse
 */
export interface LandbotCompletenessResponse {
    /**
     * 
     * @type {number}
     * @memberof LandbotCompletenessResponse
     */
    landbotChatComplete: number;
}

/**
 * Check if a given object implements the LandbotCompletenessResponse interface.
 */
export function instanceOfLandbotCompletenessResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "landbotChatComplete" in value;

    return isInstance;
}

export function LandbotCompletenessResponseFromJSON(json: any): LandbotCompletenessResponse {
    return LandbotCompletenessResponseFromJSONTyped(json, false);
}

export function LandbotCompletenessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LandbotCompletenessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'landbotChatComplete': json['landbot_chat_complete'],
    };
}

export function LandbotCompletenessResponseToJSON(value?: LandbotCompletenessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'landbot_chat_complete': value.landbotChatComplete,
    };
}

